<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryChangeMaterialProjectResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" inlineActionsDisabled :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'" exportDisabled checkboxColumnDisabled editDisable withCustomRowActions with-custom-row-actions-first-column>
                <template slot="left-header">
                  <em-button type="search"
                    v-if="pathType === 'todo'"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    :customLabel="isClaim ? '认领' : '待办'"
                    :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                    :busy="emWorkflowListLoading"
                    show-name
                    @click="switchClaim">
                  </em-button>
                </template>

                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                  <b-button-group>
                    <em-button type="task"
                      :busy="claimLoading"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      :custom-label="isClaim ? '认领' : '处理'"
                      @click="handleExecute(customRowScope.row)">
                    </em-button>
                    <em-button type="gotoChild"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      custom-icon="fa fa-fw fa-lg fa-link"
                      custom-label="查看转库物料详情"
                      @click="popSpa(customRowScope.row)">
                    </em-button>
                    <em-button type="task"
                      v-if="pathType === 'list'"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      custom-icon="fa fa-fw fa-lg fa-arrow-right"
                      custom-label="手动转库"
                      confirm-text="确认手动执行转库？"
                      :busy="onChanging"
                      @click="changeStockManually(customRowScope.row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <sub-entity-list ref="spaEntityList" sub-entity="sithMesInventoryChangeProjectDetail"
                     parent-field="changeId"></sub-entity-list>
  </div>
</template>
<script>
  // Author Lin
  // Date 2021-08-13 17:47:46
  import emWorkflowListMixin from "@/mixin/em/workflow/list";
  import emCommonGotoMixin from "@/mixin/em/common/goto";
  import EmCommonApi from "@/mixin/em/common/api";
  import subEntityList from "@/components/em/EmModal/SubEntityList";

  export default {
    name: "sithMesInventoryChangeMaterialProjectWorkflowListView",
    mixins: [emWorkflowListMixin,emCommonGotoMixin,EmCommonApi],
    components: {subEntityList},
    computed: {
      modelName() {
            return this.$_emRouterHelperMixin_entityName
      },
      $_emRouterHelperMixin_pathType() {
            return this.isClaim ? 'claim' : this.$route.query.pathType;
      },
      pathType() {
            return this.$route.query.pathType;
      },
    },
    watch: {
        pathType() {
            this.isClaim = false;
        }
    },
    data() {
        return {
          isClaim: false,
          claimLoading: false,
          onChanging: false,
        }
    },
    methods: {
      switchClaim() {
        this.isClaim = !this.isClaim;
      },
      handleExecute(row) {
        console.log(row)
        if (this.isClaim) {
            if (row.workflowTask && row.workflowTask.processDefinitionKey) {
                this.claimLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryChangeMaterialProject/claimTask",
                    data: {
                        processDefinitionKey: row.workflowTask.processDefinitionKey,
                        businessKeyList: [row.id]
                    }
                }).then(() => {
                    this.claimLoading = false;
                    this.$message.success("认领成功");
                    this.$_emWorkflowListMixin_init();
                });
            }
        } else {
            this.$_emWorkflowListMixin_handleApprove(row);
        }
      },
      popSpa(row) {
        this.$refs.spaEntityList.showModal(row.id);
      },
      changeStockManually(row) {
        let self = this;
        self.onChanging = true;
        let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/changeStockManually?taskId=${row.id}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                commonViewsUtil.showSuccess(this, "执行手动转库");
              })
              .finally(() => self.onChanging = false)
      }
    },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
        if (this.$route.query.hasOwnProperty('processId')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
            this.$refs.emListFilter.doQuery();
        }
    },
  };
</script>